import React from "react";

const Progressbar = ({ percentage, name }) => {
  return (
    <div className="lg:w-1/2 md:w-1/2 md:px-3 w-full mb-3 lg:px-3">
      <div className="flex justify-between w-full">
        <div className="text-sm font-semibold">{name}</div>
        <div className="text-sm font-semibold">{percentage}%</div>
      </div>
      <div
        className="w-full shadow-sm rounded-sm"
        style={{ backgroundColor: "#EDEBEB" }}
      >
        <div
          style={{ width: `${percentage}%`, backgroundColor: "#FFC837" }}
          className="h-4 rounded-sm"
        ></div>
      </div>
    </div>
  );
};

export default Progressbar;
